import * as React from 'react';
import Button from '@mui/material/Button';
import { rootTranslation } from 'utils/format';
import { TLicensorWithOneStop } from 'services/tracks/types';
import { useWatch } from 'react-hook-form';

const t = rootTranslation('drawers.productionSetup.tracks.createLicensors');

const oneStopCombinedMenuItems: Array<{ label: string; type: TLicensorWithOneStop }> = [
  { label: 'addone_stop', type: 'one_stop' },
  { label: 'addWriter', type: 'writer' },
  { label: 'addPublishers', type: 'publisher' },
];

const masterSyncMenuItems: Array<{ label: string; type: TLicensorWithOneStop }> = [
  { label: 'addMaster', type: 'master' },
  { label: 'addSync', type: 'sync' },
  { label: 'addWriter', type: 'writer' },
  { label: 'addPublishers', type: 'publisher' },
  { label: 'addOther', type: 'other' },
];

type AddRightsHoldersMenuProps = {
  onAddItem: (type: TLicensorWithOneStop) => void;
};

export function AddRightsHoldersMenu({ onAddItem }: AddRightsHoldersMenuProps) {
  const oneStopCombined = useWatch({ name: 'oneStopCombined' });
  const menuItems = oneStopCombined ? oneStopCombinedMenuItems : masterSyncMenuItems;

  return (
    <div style={{ display: 'flex', gap: '18px' }}>
      {menuItems.map((item) => (
        <Button
          key={item.type}
          onClick={() => onAddItem(item.type)}
          variant="outlined"
          color="secondary"
          size="small"
        >
          {t(item.label)}
        </Button>
      ))}
    </div>
  );
}
